'use strict';

/**
 * User Service
 */
module.service('regulationService', [ 'Restangular', '$q', regulationServiceFn ]);
function regulationServiceFn(Restangular, $q) {

	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */
	var regulationResource = Restangular.all('regulation');
	// var clientSimpleResource = Restangular.all('regulationsimple');

	var rs = {};

	rs.searchRegulations = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();

		regulationResource.customGET('', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.getRegulation = function(id) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customGET(id, null).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.createRegulation = function(regulation) {
		var deferred = $q.defer();
		var answer = new restResponse();

		regulationResource.post(regulation).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}

	rs.removeRegulation = function(idRegulation) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('regulation', idRegulation).remove().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}

	rs.enableRegulation = function(idRegulation) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(null, idRegulation + '/enable').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.disableRegulation = function(idRegulation) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(null, idRegulation + '/disable').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.updateRegulation = function(idRegulation, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(updateModel, idRegulation).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.searchAnalysis = function(idRegulation, filters) {
		var deferred = $q.defer();
		var answer = new restResponse();

		regulationResource.customGET(idRegulation + '/analysis', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.getRegulationAnalysis = function(idRegulation, idAnalysis) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customGET(idRegulation + '/analysis/' + idAnalysis, null).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.createRegulationAnalysis = function(idRegulation, createModel) {
		var deferred = $q.defer();
		var answer = new restResponse();

		regulationResource.customPOST(createModel, idRegulation + '/analysis').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}

	rs.removeRegulationAnalysis = function(idRegulation, idAnalisys) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('regulation', idRegulation).one('analysis', idAnalisys).remove().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}

	rs.updateRegulationAnalysis = function(idRegulation, idAnalisys, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(updateModel, idRegulation + '/analysis/' + idAnalisys).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.enableAnalysis = function(idRegulation, idAnalysis) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(null, idRegulation + "/analysis/" + idAnalysis + '/enable').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.disableAnalysis = function(idRegulation, idAnalysis) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(null, idRegulation + "/analysis/" + idAnalysis + '/disable').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.searchTechnique = function(idRegulation, idAnalysis, filters) {
		var deferred = $q.defer();
		var answer = new restResponse();

		regulationResource.customGET(idRegulation + '/analysis/' + idAnalysis + '/technique', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.getValuesRegulation = function(idRegulation, idAnalysis) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customGET(idRegulation + '/analysis/' + idAnalysis + '/values', null).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.searchRegulationAnalysisTechnique = function(filter) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customGET('regulationAnalysisTechnique', filter).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.createTechnique = function(idRegulation, idAnalisys, createModel) {
		var deferred = $q.defer();
		var answer = new restResponse();

		regulationResource.customPOST(createModel, idRegulation + '/analysis/' + idAnalisys + '/technique').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}

	rs.removeTechnique = function(idRegulation, idAnalisys, idTechnique) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('regulation', idRegulation).one('analysis', idAnalisys).one('technique', idTechnique).remove().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}
	
	rs.removeTechniqueInRegulation = function(idRegulation, idAnalisys, idTechnique) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('regulation', idRegulation).one('analysis', idAnalisys).one('technique', idTechnique).one('InRegulation', '').remove().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}

	rs.updateTechnique = function(idRegulation, idAnalysis, idTechnique, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(updateModel, idRegulation + '/analysis/' + idAnalysis + '/technique/' + idTechnique).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}
	
	
	rs.updateValues = function(idRegulation, idAnalysis, updateModel) {
		var deferred = $q.defer();
		var answer = new restResponse();
		
	
		Restangular.one('regulation', idRegulation).one('analysis', idAnalysis).one('update','').customPUT(updateModel).then(function(response) {

			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.enableTechnique = function(idRegulation, idAnalysis, idTechnique) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(null, idRegulation + "/analysis/" + idAnalysis + '/technique/' + idTechnique + '/enable').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.disableTechnique = function(idRegulation, idAnalysis, idTechnique) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(null, idRegulation + "/analysis/" + idAnalysis + '/technique/' + idTechnique + '/disable').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	}

	rs.removeTechniqueSamplingMethod = function(idRegulation, idAnalisys, idTechnique, idSamplingMethod) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('regulation', idRegulation).one('analysis', idAnalisys).one('technique', idTechnique).one('samplingmethod', idSamplingMethod).remove()
				.then(function(response) {
					answer.handleSuccessfullResponse(response, response.data);
					deferred.resolve(answer);
				}, function(response) {
					answer.handleErrorResponse(response, response.data);
					deferred.reject(answer);
				});

		return deferred.promise;
	}

	rs.addTechniqueSamplingMethod = function(idRegulation, idAnalisys, idTechnique, samplingMethod) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('regulation', idRegulation).one('analysis', idAnalisys).one('technique', idTechnique).customPOST(samplingMethod, 'samplingmethod')
				.then(function(response) {
					answer.handleSuccessfullResponse(response, response.data);
					deferred.resolve(answer);
				}, function(response) {
					answer.handleErrorResponse(response, response.data);
					deferred.reject(answer);
				});

		return deferred.promise;
	}

	rs.updateTechniqueSamplingMethod = function(idRegulation, idAnalisys, idTechnique, idSamplingMethod, samplingMethod) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('regulation', idRegulation).one('analysis', idAnalisys).one('technique', idTechnique).one('samplingmethod', idSamplingMethod)
				.customPUT(samplingMethod).then(function(response) {
					answer.handleSuccessfullResponse(response, response.data);
					deferred.resolve(answer);
				}, function(response) {
					answer.handleErrorResponse(response, response.data);
					deferred.reject(answer);
				});

		return deferred.promise;
	}

	rs.searchAnalysisSamplingMethod = function(idRegulation, filters) {
		var deferred = $q.defer();
		var answer = new restResponse();

		Restangular.one('regulation', idRegulation).customGET('samplingmethod', filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}
	
	rs.addAnalysisInRegulation = function(model) {
		var deferred = $q.defer();
		var answer = new restResponse();

		regulationResource.customPOST(model,'addanalysis').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}
	
	rs.addTechniqueInRegulation = function(idRegulation,idAnalysis,idTechnique) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one('regulation', idRegulation).one('analysis', idAnalysis).one('technique', idTechnique).one('method','').customPUT().then(function(response) {	
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}
	
	rs.addValuesInRegulation = function(idRegulation,model) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(model, idRegulation + '/addValues').then(function(response) {	
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}
	
	rs.addTechniqueInAnalysis = function(idRegulation,idAnalysis,idTechnique,model) {
		var deferred = $q.defer();
		var answer = new restResponse();
		regulationResource.customPUT(model, idRegulation + '/analysis/' + idAnalysis + '/technique/' + idTechnique + '/add').then(function(response) {	
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});

		return deferred.promise;
	}

	return rs;
}